/**
 * Included into the header of pages.
 */

// JQuery - Provide our own in place of what WordPress ships with. In functions.php we also dequeue the built in jquery
import './lib/JQueryGlobal';